import { FileInputComponentDef } from '@df/ui/form/file-input.component.def';
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'file-input',
    standalone: true,
    templateUrl: './file-input.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileInputComponent extends FileInputComponentDef {}
